"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

function state() {
  var root = {};
  var scoped = {};
  return {
    set: function set(key, value) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var readonly = options.readonly,
          scope = options.scope;
      var store = root;

      if (scope) {
        if (!scoped[scope]) scoped[scope] = {};
        store = scoped[scope];
      }

      var contained = store[key];

      if (contained === null || contained === void 0 ? void 0 : contained.readonly) {
        return false;
      }

      store[key] = {
        value: value,
        readonly: readonly
      };
      return true;
    },
    get: function get(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var scope = options.scope;

      if (scope) {
        var _scoped$scope;

        var _contained = (_scoped$scope = scoped[scope]) === null || _scoped$scope === void 0 ? void 0 : _scoped$scope[key];

        if (_contained) return _contained.value;
      } // fall through and check for value in root scope if no scoped value was found for the key


      var contained = root[key];
      if (contained) return contained.value;
    }
  };
}

var _default = state;
exports.default = _default;